module.exports = __webpack_public_path__ + "static/media/p_3_2.712dfd0e.png";